import type React from 'react';

import { Button } from '@change/ds-core-ui/Button';
import { Text } from '@change/ds-core-ui/Text';
import { FocusRing } from '@change/ds-core-ui/util';

import { Translate } from '@change-corgi/core-react/i18n';

import { EndorsementModal } from '../EndorsementModal';

import { EndorsementSectionWithList } from './components/EndorsementSectionWithList';
import { descriptionContainer, sectionContainer, titleContainer } from './EndorsementSection.styles';
import { useEndorsementSection } from './hooks/useEndorsementSection';

export const EndorsementSection: React.FC<EmptyProps> = () => {
	const { isEmpty, isHelpModalOpen, setIsHelpModalOpen, handleAddAnother, handleSeeExampleClick } =
		useEndorsementSection();

	return (
		<div className={sectionContainer()} data-testid="endorsement-section" id="endorsements">
			<div className={titleContainer()}>
				<Text as="h2" variant="heading" size="x-small" fontWeight="bold" className="text-typography-strong">
					<Translate value="corgi.petition.edit.endorsements.title" />
				</Text>
			</div>

			<div className={descriptionContainer()}>
				<Text variant="body" className="text-typography-strong">
					<Translate value="corgi.petition.edit.endorsements.initial_description" />{' '}
					<em>
						<Translate value="corgi.petition.edit.endorsements.description_emphasis" />
					</em>{' '}
					<Translate value="corgi.petition.edit.endorsements.description_suffix" />{' '}
					<FocusRing focusRingClass="rounded-sm">
						<button
							type="button"
							className="text-typography-interactive cursor-pointer border-none bg-transparent p-0 whitespace-nowrap underline"
							onClick={handleSeeExampleClick}
						>
							<Translate value="corgi.petition.edit.endorsements.see_example" />
						</button>
					</FocusRing>
				</Text>
			</div>

			{isEmpty && (
				<Button
					onClick={handleAddAnother}
					variant="secondary"
					size="x-small"
					className="w-full md:w-fit"
					data-testid="add-endorsement-button"
				>
					<Translate value="corgi.petition.edit.endorsements.add_endorsement_button" />
				</Button>
			)}
			{!isEmpty && <EndorsementSectionWithList />}

			<EndorsementModal variant="help" isOpen={isHelpModalOpen} onClose={() => setIsHelpModalOpen(false)} />
		</div>
	);
};
